import productDefectReducer from './reducers'

export { default as productDefectSelectors } from './selectors'
export { default as productDefectActions } from './actions'
export { default as productDefectTypes } from './actionTypes'

export default productDefectReducer
